import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';

const DEFAULT_TRANSITION_DURATION = 300;

const SlideIn = ({
    transitionDuration = DEFAULT_TRANSITION_DURATION,
    children,
}) => {
    const [triggered, setTriggered] = useState(false);

    useEffect(() => {
        setTriggered(true);
    }, []);

    return (
        <Collapse in={ triggered } timeout={ transitionDuration }>
            {children}
        </Collapse>
    );
};

SlideIn.propTypes = {
    transitionDuration: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default SlideIn;
